module.exports = __webpack_public_path__ + "img/RL.dd6c45e5.png";